import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TOrganisation {
  id: number;
  name: string;
  hrmsInstitutionCode: string;
  valid: boolean;
}

export interface IOrganisation extends TOrganisation {}

const Organisation = Model((model: TOrganisation): IOrganisation => {
  const _value: TOrganisation = Object.assign({}, model);

  let _model = {
    get id() {
      return _value.id;
    },
    set id(value) {
      _value.id = value;
    },
    get name() {
      return _value.name;
    },
    set name(value) {
      _value.name = value;
    },
    get hrmsInstitutionCode() {
      return _value.hrmsInstitutionCode;
    },
    set hrmsInstitutionCode(value) {
      _value.hrmsInstitutionCode = value;
    },
    get valid() {
      return _value.valid;
    },
    set valid(value) {
      _value.valid = value;
    }
  };

  return ValidatableObject<IOrganisation>(_model);
});

export default Organisation;
